// `React` must be in SCOPE, not merely resolvable: the kiosk renderchecks run ts-node with
// `"jsx": "react"` (the classic runtime), which compiles this file's JSX to
// `React.createElement`. The app bundlers use the automatic runtime and need no import, so a
// missing one here builds clean and throws only in those node-only gates.
import React from "react";
import Svg, { Path } from "react-native-svg";

/**
 * The tapping hand drawn above the idle screen's "TOUCH ANYWHERE TO START ORDER" prompt.
 *
 * Figma export, node 355:2876 — the path below is that export's `d` verbatim on its native
 * 47×47 grid, so it is never re-traced by hand.
 *
 * Two wrappers from the export are dropped on purpose. Its `<clipPath>` and its `<mask>` are
 * both the full 46.8×46.8 bounds, so neither removes a single pixel; carried over they would
 * only add two more global SVG ids to collide with (RNSVG shares one id namespace per
 * document, and the idle screen already defines the scrim's gradient id). The hardcoded
 * `fill="white"` becomes the `color` prop the sibling assets all take.
 */
export function TouchIcon({
  color,
  width,
  height,
}: {
  color: string;
  width?: number;
  height?: number;
}) {
  return (
    <Svg width={width ?? 47} height={height ?? 47} viewBox="0 0 47 47" fill="none">
      <Path
        fill={color}
        d="M20.4283 42.9053C19.5182 42.9053 18.6651 42.7103 17.8687 42.3202C17.0724 41.9302 16.3979 41.3777 15.8454 40.6626L5.2168 27.1574L6.14314 26.1824C6.79321 25.4998 7.57328 25.0935 8.48338 24.9634C9.39347 24.8335 10.2386 25.0122 11.0187 25.4998L14.6265 27.6938V11.7022C14.6265 11.1496 14.8134 10.6864 15.1872 10.3127C15.5609 9.93885 16.0242 9.75196 16.5767 9.75196C17.1293 9.75196 17.6005 9.93885 17.9906 10.3127C18.3806 10.6864 18.5757 11.1496 18.5757 11.7022V34.7144L13.8464 31.7892L18.9169 38.2736C19.1119 38.5011 19.3395 38.6799 19.5995 38.8099C19.8595 38.9399 20.1358 39.0049 20.4283 39.0049H31.2032C32.2758 39.0049 33.194 38.623 33.9578 37.8592C34.7216 37.0954 35.1036 36.1771 35.1036 35.1045V27.3037C35.1036 26.7512 34.9167 26.288 34.5429 25.9142C34.1691 25.5405 33.7059 25.3535 33.1534 25.3535H22.476V21.4532H33.1534C34.7785 21.4532 36.1599 22.022 37.2976 23.1596C38.4352 24.2971 39.0039 25.6785 39.0039 27.3037V35.1045C39.0039 37.2498 38.2401 39.0862 36.7125 40.6138C35.1849 42.1414 33.3483 42.9053 31.2032 42.9053H20.4283ZM8.14209 16.5777C7.71955 15.8626 7.39452 15.0906 7.16699 14.2618C6.93948 13.4329 6.82571 12.5797 6.82571 11.7022C6.82571 9.00439 7.77644 6.70478 9.67788 4.80334C11.5793 2.90189 13.879 1.95117 16.5767 1.95117C19.2745 1.95117 21.5741 2.90189 23.4755 4.80334C25.377 6.70478 26.3277 9.00439 26.3277 11.7022C26.3277 12.5797 26.2139 13.4329 25.9864 14.2618C25.7588 15.0906 25.4339 15.8626 25.0112 16.5777L21.6472 14.6274C21.9072 14.1724 22.1023 13.7092 22.2323 13.238C22.3622 12.7666 22.4273 12.2547 22.4273 11.7022C22.4273 10.077 21.8585 8.6956 20.7209 7.55799C19.5832 6.42037 18.2018 5.85157 16.5767 5.85157C14.9515 5.85157 13.5701 6.42037 12.4325 7.55799C11.2949 8.6956 10.7261 10.077 10.7261 11.7022C10.7261 12.2547 10.7911 12.7666 10.9211 13.238C11.0512 13.7092 11.2462 14.1724 11.5062 14.6274L8.14209 16.5777Z"
      />
    </Svg>
  );
}
TouchIcon.displayName = "TouchIcon";
export default TouchIcon;
